import { render, staticRenderFns } from "./UnitSettings.vue?vue&type=template&id=6e906537"
import script from "./UnitSettings.vue?vue&type=script&lang=ts"
export * from "./UnitSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e906537')) {
      api.createRecord('6e906537', component.options)
    } else {
      api.reload('6e906537', component.options)
    }
    module.hot.accept("./UnitSettings.vue?vue&type=template&id=6e906537", function () {
      api.rerender('6e906537', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/UnitSettings.vue"
export default component.exports